<template>
  <vx-card no-shadow title="Create Practice Area Custom">
    <a-button type="primary" icon="plus" class="mb-5" style="border-radius: 3px !important;" @click="handleAdd">
      Create Practice Area
    </a-button>
    <a-card>
      <ASpin :spinning="loading_list" :indicator="indicator">
          <a-list item-layout="horizontal" :data-source="list_practice">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-tooltip slot="actions" placement="bottomLeft">
                  <a-popconfirm
                    title="Are you sure want to delete?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="deletePracticeArea(item.id)"
                  >
                    <a style="color: red">Delete</a>
                  </a-popconfirm>
                </a-tooltip>
                <a slot="actions" @click="editItemPracticeArea(item)">Edit</a>
                <a-list-item-meta>
                  <a slot="title" href="#" @click="editItemPracticeArea(item)">{{ item.title }}</a>
                </a-list-item-meta>
              </a-list-item>
          </a-list>
      </ASpin>
    </a-card>
    <ModalPracticeArea
      ref="modal"
      :edit_mode="edit_mode"
      :row_list="row_list"
      :getPracticeArea="getPracticeArea"
    />
  </vx-card>
</template>

<script>

    import mixin from '../../../mixin/mixin'
    import axios from '@/axios'
    import ModalPracticeArea from './modalpracticeArea/ModalPracticeArea'

    export default {
        name: "PracticeArea",
        mixins:[mixin],
        components:{
          ModalPracticeArea
        },
        data(){
          return{
            loading     : false,
            data        : [],
            edit_mode   : false,
            row_list    : null
          }
        },
        methods: {
          handleAdd() {
            this.edit_mode = false
            this.$refs.modal.visible = true
            this.$refs.modal.form.resetFields()
          },
          editItemPracticeArea(item){
            this.$refs.modal.visible = true
            this.edit_mode           = true
            this.row_list            = item
            this.$nextTick(()=>this.$refs.modal.form.setFieldsValue({ title: item.title }))
          },
          async deletePracticeArea(id){
            try{
              this.loading_list = true
              await axios.delete(`/practice-area/${id}/`)
              this.$notification['success']({
                message: 'Success',
                description: 'Item successfully removed.'
              })
              await this.getPracticeArea()
            }catch (e) {
              this.$message.error('Server error')
              throw e
            }finally {
              this.loading_list = false
            }
          },
        },
        mounted() {
          this.getPracticeArea()
        }
    }
</script>

<style>
  [dir] .select .ant-select-selection.ant-select-selection--single{
    border-radius: 3px !important;
  }
</style>
